"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
var card_type_model_1 = require("../../../../layout-models/card-type.model");
var kb_tree_model_1 = require("../../../../layout-models/form-models/kb-tree.model");
var form_dragula_options_1 = require("../form-dragula-options");
require("./form-kb-tree.component.scss");
var FormKbTreeComponent = /** @class */ (function () {
    function FormKbTreeComponent(kbService, moduleRegistryService) {
        this.kbService = kbService;
        this.moduleRegistryService = moduleRegistryService;
        this.cardTypes = [];
        this.nestedCardTypes = [];
        this.headerModels = [];
        this.tabModels = [];
        this.metaFieldTypes = idm_kb_service_client_js_1.MetaFieldType;
        this.subwayMapModels = [];
        this.dragulaOptions = new form_dragula_options_1.FormDragulaOptions();
    }
    FormKbTreeComponent.prototype.isMainForm = function () {
        return this.formEntityType === idm_dynamic_layout_interpreter_1.FormEntityType.MAIN_FORM;
    };
    FormKbTreeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.kbService.getCategoryManagerMetaCategories().subscribe(function (a) { return (_this.allMetaCategories = a); }, function (error) { return console.error(error); });
        this.treeKB = new kb_tree_model_1.KbTreeModel();
        var metaGroups$ = zip_1.zip(this.kbService.getAllMetaGroups(this.categoryName), this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this.categoryName))).pipe(operators_1.map(function (_a) {
            var metaGroups = _a[0], metaCategory = _a[1];
            if (_this.formEntityType === idm_dynamic_layout_interpreter_1.FormEntityType.WORKFLOW_FORM) {
                return metaGroups;
            }
            var actionData = new Set(metaCategory
                .getActionDataMetaFieldIds()
                .map(function (metaField) { return metaField.getSystemName(); }));
            return metaGroups
                .map(function (group) {
                var metaFields = group
                    .getMetaFields()
                    .filter(function (field) { return !actionData.has(field.getSystemName()); });
                if (metaFields.length === 0) {
                    return undefined;
                }
                return new idm_kb_service_client_js_1.MetaGroup(group.getSystemName(), group.getDisplayName(), metaFields, group.getDisplayNameMultilingual());
            })
                .filter(skynet_store_utilities_1.notNil);
        }));
        this.isReady$ = zip_1.zip(metaGroups$, this.moduleRegistryService.availableControls().pipe(operators_1.tap(function (metaControls) {
            metaControls.forEach(function (metaControl) {
                if (metaControl.isHeader) {
                    _this.headerModels.push(metaControl);
                }
                else if (metaControl.isSubwayMap) {
                    _this.subwayMapModels.push(metaControl);
                }
            });
        }))).pipe(operators_1.tap(function (_a) {
            var metaGroups = _a[0], metaControls = _a[1];
            _this.treeKB.createTreeFromGroups(metaGroups, _this.moduleRegistryService);
            _this.cardTypes.push(new card_type_model_1.CardTypeModel('Card', 'de.form_builder.card'));
            _this.nestedCardTypes.push(new card_type_model_1.CardTypeModel('Nested Card', 'de.form_builder.nested_card'));
            _this.tabModels.push({});
        }), operators_1.tap(noop_1.noop, console.error), operators_1.map(function () { return true; }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], FormKbTreeComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FormKbTreeComponent.prototype, "isHeaderExists", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FormKbTreeComponent.prototype, "isTabBarExists", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], FormKbTreeComponent.prototype, "formEntityType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FormKbTreeComponent.prototype, "isSubwayMapExists", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], FormKbTreeComponent.prototype, "currentLanguageId", void 0);
    FormKbTreeComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'form-kb-tree',
            template: require('./form-kb-tree.component.html'),
        }),
        __param(1, core_1.Inject(idm_dynamic_layout_interpreter_1.formModuleRegistryKey)),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_dynamic_layout_interpreter_1.ModuleRegistryService])
    ], FormKbTreeComponent);
    return FormKbTreeComponent;
}());
exports.FormKbTreeComponent = FormKbTreeComponent;
//# sourceMappingURL=form-kb-tree.component.js.map